import { type QueryClient } from "@tanstack/react-query";

export function invalidateWorkerLockQueries(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({
    predicate: (query) => {
      const [url] = query.queryKey;
      return typeof url === "string" && url.includes("/visit-lock");
    },
  });
}
